<template>
  <div>
    <b-col>
      <hr />
      <b-row>
        <b-col md="6" style="border-right: 1px solid lightgrey">
          <b-row>
            <b-col>
              <c-input
                inputType="text"
                inputId="idproofNo"
                lableText="ID Proof No. *"
                v-model="kyc.idproofNo"
                @input="$emit('readKYC', kyc)"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <p>Photo ID Front</p>
              <single-image
                height="150px"
                width="115px"
                @change="(d) => uploadImage('photoIdFront', d)"
                :id="'photo_id_front'"
                :url="kyc.photoIdFront"
                label="Photo ID Front"
              ></single-image>
            </b-col>
            <b-col md="6">
              <p>Photo ID Back</p>
              <single-image
                height="150px"
                width="115px"
                @change="(d) => uploadImage('photoIdBack', d)"
                :id="'photo_id_back'"
                :url="kyc.photoIdBack"
                label="Photo ID Back"
              ></single-image>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="6">
          <b-row>
            <b-col>
              <c-input
                inputType="text"
                inputId="addressproofNo"
                lableText="Address Proof No. *"
                v-model="kyc.addressproofNo"
                @input="$emit('readKYC', kyc)"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <p>Add Proof Front</p>
              <single-image
                height="150px"
                width="115px"
                @change="(d) => uploadImage('addressProofFront', d)"
                :id="'address_proof_front'"
                :url="kyc.addressProofFront"
                label="Address Photo"
              ></single-image>
            </b-col>
            <b-col md="6">
              <p>Add Proof Back</p>
              <single-image
                height="150px"
                width="115px"
                @change="(d) => uploadImage('addressProofBack', d)"
                :id="'address_proof_back'"
                :url="kyc.addressProofBack"
                label="Address Proof Back"
              ></single-image>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr />
    </b-col>
    <slot name="footer-button" :data="kyc"></slot>
  </div>
</template>

<script>
import Vue from "vue";
import SingleImage from "../../components/Common/Image.vue";
import cInput from "@/components/FormElements/CustomInput.vue";
export default {
  components: {
    SingleImage,
    cInput,
  },
  props: ["kycData"],
  mounted() {
    if (this.kycData && typeof this.kycData === "object") {
      this.kyc = this.kycData;
    }
  },
  data() {
    return {
      kyc: {
        addressProofFront: "",
        addressProofBack: "",
        photoIdFront: "",
        photoIdBack: "",
        idproofNo: "",
        addressproofNo: "",
      },
      status: {
        idProofuploaded: false,
        addressProofuploaded: false,
      },
    };
  },
  methods: {
    showCustomToast() {
      Vue.toasted.show("Uploading...", {
        type: "info",
        theme: "toasted-primary",
        singleton: true,
        duration: 1000000,
      });
    },
    clearCustomToast() {
      Vue.toasted.clear();
    },
    async uploadImage(path, image) {
      let dataobj = {
        image: image,
        key: (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase(),
        isPublic: true,
        replaceExisting: true,
        basePath: ["kyc", "agent"],
      };
      this.showCustomToast();
      await this.$store
        .dispatch("inventory/uploadImageToStorage", dataobj)
        .then((res) => {
          this.clearCustomToast();
          this.kyc[path] = res.data.fileUrl;
          this.$emit("readKYC", this.kyc);
        })
        .catch((error) => {
          this.clearCustomToast();
          this.$toasted.error("Image not uploaded..please try again!");
        });
    },
    async submitKyc(userId) {
      const payload = {
        userId: userId,
        documents: [
          {
            category: "ID_PROOF",
            docType: "ID_PROOF",
            docuementNo: this.kyc.idproofNo,
            frontSideFilePath: this.kyc.photoIdFront,
            backSideFilePath: this.kyc.photoIdBack,
          },
          {
            category: "ADDRESS_PROOF",
            docType: "ADDRESS_PROOF",
            docuementNo: this.kyc.addressproofNo,
            frontSideFilePath: this.kyc.addressProofFront,
            backSideFilePath: this.kyc.addressProofBack,
          },
        ],
      };
      try {
        await this.$store.dispatch("tenant/submitKYCByUser", payload);
        this.showAlert("Success", "Success", "KYC Submitted For Agent");
      } catch (e) {
        this.showAlert("Error", "Error", "Error Submitting Kyc");
      }
      return;
    },
    showAlert(type, title, text) {
      this.$swal({
        title,
        text,
        type,
      });
    },
  },
};
</script>
<style scoped>
[btn-color="primary"] {
  height: 41px;
  background-color: #727cf5;
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: 'Lato';
  color: white;
  border: 0px;
  border-radius: 0px;
}
[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: 'Lato';
  border-radius: 0px;
  height: 43px;
  width: 139px;
  background-color: #727cf5;
  color: white;
}
</style>
